import styled, { css } from 'styled-components';

export const UIPrice = styled.div`
  display: flex;
  font-size: 14px;
  flex-wrap: wrap;
  align-items: center;
  color: var(--text-color);

  ${({ smallType }) => smallType
    && css`
      font-size: 12px;
    `}

  .text-price-from {
    font-size: 12px;
    margin-right: 5px;
  }

  .promotional-price {
    font-weight: 500;
    margin-left: 5px;
    color: var(--promotional-color);
  }

  ${({ hasPromotionalPrice }) => hasPromotionalPrice
    && css`
      .price {
        font-size: 12px;
        text-decoration: line-through;
        color: var(--text-secondary-color);
      }
    `}
`;
